/**
* Finds the value of a query string parameter (if it exists).
*
* @param {String} field - The key to find a value for.
* @return {(String|null)} That key's value if it exists. Otherwise null.
*/
export default function(field) {
  const href = window.location.href;
  const reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
  const string = reg.exec(href);

  return string ? string[1] : null;
}
